import * as Yup from 'yup'; 
import { firstLetterCapitalized, onlyNumbers } from '../../components/form/Helpers/Parsers'
import { isDateValid, isNotEarlierDate, isNotFutureDate } from '../../components/form/Validations/DateValidation'
import { FieldTypes, IFields, InputModes } from '../../models/form/IFieldsDefinition'
import { IncomeTypeEnum } from './IncomeTypes'
import { incomeReceivedDayList } from './IncomeInfoFields'
import { hasNIPCorrectFormat } from '../../components/form/Validations/NIPValidation'
import { FormValidationObject } from '../../models/form/IFormDefinition'
import { InputBooleanOptions } from '../../components/form/Fields/InputDropdown/InputDropdownProps'


export enum AdditionalIncomeBasicFieldsNames {
   AdditionalIncomeType = 'AdditionalIncomeType'
}


export enum AdditionalIncomeAdditionalFieldsNames  {
   AdditionalIncomeWorkplaceNIP = 'AdditionalIncomeWorkplaceNIP',
   AdditionalIncomeWorkplaceName = 'AdditionalIncomeWorkplaceName',
   AdditionalIncomeEmploymentFromDate = 'AdditionalIncomeEmploymentFromDate',
   AdditionalIncomeBenefitRecivedFromDate = 'AdditionalIncomeBenefitRecivedFromDate',
   AdditionalIncomeSoleProprietorshipFromDate = 'AdditionalIncomeSoleProprietorshipFromDate',
   AdditionalIncomeFarmRunningFromDate = 'AdditionalIncomeFarmRunningFromDate',
   AdditionalIncomeRentalFromDate = 'AdditionalIncomeRentalFromDate',
   AdditionalIncomeIsEmploymentIndefinitely = 'AdditionalIncomeIsEmploymentIndefinitely',
   AdditionalIncomeIsBenefitIndefinitely = 'AdditionalIncomeIsBenefitIndefinitely',
   AdditionalIncomeEmploymentToDate = 'AdditionalIncomeEmploymentToDate',
   AdditionalIncomeRentalToDate = 'AdditionalIncomeRentalToDate',
   AdditionalIncomeBenefitRecivedToDate = 'AdditionalIncomeBenefitRecivedToDate',
   AdditionalIncomePerMonthNetto = 'AdditionalIncomePerMonthNetto',
   AdditionalIncomeIncomeReceivedDay = 'AdditionalIncomeIncomeReceivedDay',
   AdditionalIncomeNIP = 'AdditionalIncomeNIP',
   AdditionalIncomeCompanyName = 'AdditionalIncomeCompanyName',
   AdditionalIncomeHasUnionGrants = 'AdditionalIncomeHasUnionGrants',
   AdditionalIncomeUnionGrantAmount = 'AdditionalIncomeUnionGrantAmount',
}

const EmploymentContractFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceNIP,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceName,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsEmploymentIndefinitely,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const

const RetirementFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const

const ContractFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceNIP,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceName,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsEmploymentIndefinitely,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const


const PensionFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsBenefitIndefinitely,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const


const SoleProprietorshipFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeSoleProprietorshipFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeNIP,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeCompanyName,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const


const CommissionAgreementFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceNIP,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceName,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsEmploymentIndefinitely,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const


const FarmFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeFarmRunningFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeHasUnionGrants,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const


const RentalFields: readonly AdditionalIncomeAdditionalFieldsNames[] = [
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalFromDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalToDate,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
   AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
] as const



export const additionalIncomeType = [
   {  value: IncomeTypeEnum.EmploymentContract,   fields: EmploymentContractFields,     label: 'Umowa o pracę',           },
   {  value: IncomeTypeEnum.Retirement,           fields: RetirementFields,             label: 'Emerytura',               },
   {  value: IncomeTypeEnum.Contract,             fields: ContractFields,               label: 'Kontrakt',                },
   {  value: IncomeTypeEnum.Pension,              fields: PensionFields,                label: 'Renta',                   },
   {  value: IncomeTypeEnum.SoleProprietorship,   fields: SoleProprietorshipFields,     label: 'Działalność gospodarcza', },
   {  value: IncomeTypeEnum.CommissionAgreement,  fields: CommissionAgreementFields,    label: 'Umowa zlecenie',          },
   {  value: IncomeTypeEnum.Farmer,               fields: FarmFields,                   label: 'Działalność rolnicza',    },
   {  value: IncomeTypeEnum.Rental,               fields: RentalFields,                 label: 'Najem',                   },
]



export const additionalIncomeBaseInfoFieldsDefinition: IFields = {
   [AdditionalIncomeBasicFieldsNames.AdditionalIncomeType]: {
      order: 0,
      name: AdditionalIncomeBasicFieldsNames.AdditionalIncomeType,
      type: FieldTypes.dropdownChangeIncomeTypeField,
      label: "Dodatkowe źródło dochodu",
      options: additionalIncomeType,
      editable: true,
   },
}

export const additionalIncomeAdditionalInfoFieldsDefinition: IFields = {
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceName]: {
      order: 5,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceName,
      label: "Nazwa Pracodawcy",
      type: FieldTypes.string,
      maxLength: 50,
      editable: true,
      parser: firstLetterCapitalized,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceNIP]: {
      order: 6,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceNIP,
      label: "NIP Pracodawcy",
      type: FieldTypes.string,
      editable: true,
      maxLength: 10,
      isAdditionalField: true,
      inputMode: InputModes.numeric,
      parser: onlyNumbers,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentFromDate]: {
      order: 7,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentFromDate,
      label: "Data zatrudnienia od",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedFromDate]: {
      order: 5,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedFromDate,
      label: "Od kiedy uzyskiwane jest świadczenie?",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeSoleProprietorshipFromDate]: {
      order: 7,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeSoleProprietorshipFromDate,
      label: "Data rozpoczęcia działalności",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeFarmRunningFromDate]: {
      order: 5,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeFarmRunningFromDate,
      label: "Data rozpoczęcia działalności rolniczej",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalFromDate]: {
      order: 5,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalFromDate,
      label: "Data rozpoczęcia najmu lokalu",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsEmploymentIndefinitely]: {
      order: 8,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsEmploymentIndefinitely,
      label: "Czy jesteś zatrudniony bezterminowo?",
      type: FieldTypes.boolean,
      options: [
         { value: false, label: InputBooleanOptions.agree }, // Pytanie tak skonstruowane, że wartość odpowiedzi negatywnej musi być wartością "true", a pozytywnej "false"
         { value: true, label: InputBooleanOptions.disagree }
      ],
      isAdditionalField: true,
      editable: true,
      associatedFieldName: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsBenefitIndefinitely]: {
      order: 6,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsBenefitIndefinitely,
      label: "Czy świadczenie jest bezterminowe?",
      type: FieldTypes.boolean,
      options: [
         { value: false, label: InputBooleanOptions.agree }, // Pytanie tak skonstruowane, że wartość odpowiedzi negatywnej musi być wartością "true", a pozytywnej "false"
         { value: true, label: InputBooleanOptions.disagree }
      ],
      isAdditionalField: true,
      editable: true,
      associatedFieldName: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedToDate,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate]: {
      order: 9,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate,
      label: "Data zatrudnienia do", 
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalToDate]: {
      order: 10,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalToDate,
      label: "Data zakończenia najmu lokalu", 
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedToDate]: {
      order: 7,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedToDate,
      label: "Do kiedy przyznane jest świadczenie",
      type: FieldTypes.date,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto]: {
      order: 10,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto,
      label: "Dochód miesięczny netto",
      type: FieldTypes.number,
      maxLength: 10,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay]: {
      order: 25,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay,
      label: "Dzień wpływu wynagrodzenia",
      type: FieldTypes.dropdown, 
      options: incomeReceivedDayList,
      editable: true,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeNIP]: {
      order: 5,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeNIP,
      label: "NIP firmy",
      type: FieldTypes.string,
      editable: true,
      maxLength: 10,
      isAdditionalField: true,
      inputMode: InputModes.numeric,
      parser: onlyNumbers,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeCompanyName]: {
      order: 6,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeCompanyName,
      label: "Nazwa firmy",
      type: FieldTypes.string,
      maxLength: 50,
      editable: true,
      parser: firstLetterCapitalized,
      isAdditionalField: true,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeHasUnionGrants]: {
      order: 15,
      name: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeHasUnionGrants,
      label: "Czy posiadasz dochód z dotacji uninej?",
      type: FieldTypes.boolean,
      options: [
         { value: true, label: InputBooleanOptions.agree },
         { value: false, label: InputBooleanOptions.disagree }
      ],
      editable: true,
      isAdditionalField: true,
      associatedFieldName: AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeUnionGrantAmount,
   },
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeUnionGrantAmount]: {
      order: 20,
      name:AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeUnionGrantAmount,
      label: "Łączna kwota dotacji",
      type: FieldTypes.number,
      maxLength: 10,
      editable: true,
      isAdditionalField: true,
   },
}



export const  additionalIncomeInfoFieldValidations: FormValidationObject<typeof AdditionalIncomeBasicFieldsNames> & FormValidationObject<typeof AdditionalIncomeAdditionalFieldsNames> = {
   [AdditionalIncomeBasicFieldsNames.AdditionalIncomeType]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   
   
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceName]: Yup.string().trim().required("Niepoprawna wartość").min(2, "Niepoprawna wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeWorkplaceNIP]: Yup.string().required("Niepoprawna wartość").test(hasNIPCorrectFormat) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeSoleProprietorshipFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeFarmRunningFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalFromDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotFutureDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsEmploymentIndefinitely]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIsBenefitIndefinitely]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeEmploymentToDate]:  Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotEarlierDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeRentalToDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotEarlierDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeBenefitRecivedToDate]: Yup.string().required("Nieprawidłowa wartość").test(isDateValid).test(isNotEarlierDate) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomePerMonthNetto]: Yup.string().required("Nieprawidłowa wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeIncomeReceivedDay]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeNIP]: Yup.string().required("Niepoprawna wartość").test(hasNIPCorrectFormat) as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeCompanyName]: Yup.string().trim().required("Niepoprawna wartość").min(2, "Niepoprawna wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeHasUnionGrants]: Yup.string().required("Niepoprawna wartość") as Yup.StringSchema<string>,
   [AdditionalIncomeAdditionalFieldsNames.AdditionalIncomeUnionGrantAmount]: Yup.string().required("Nieprawidłowa wartość") as Yup.StringSchema<string>,
}